import React from 'react';

const NavIcon: React.FC<{ icon: string }> = ({ icon }) => {
  return <i className="material-symbols-outlined nav-icon">{icon}</i>;
};

export default NavIcon;
